module.exports = __webpack_public_path__ + "media/images/logo-7637643e7f865cf2e5ed1c9efd450f4b.png";